import PropTypes from 'prop-types';

function MMWineActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11314)">
                <path
                    d="M17.9688 3.06412C20.5969 3.51086 22.7804 3.56196 22.8456 3.17826C22.9108 2.79456 20.8331 2.12136 18.205 1.67462C15.5768 1.22788 13.3934 1.17677 13.3282 1.56048C13.263 1.94418 15.3406 2.61738 17.9688 3.06412Z"
                    fill="#D9D9D9"
                />
                <path
                    d="M13.3276 1.56065C13.3276 1.56065 9.76124 5.76106 10.2736 9.46011C10.786 13.1592 14.3885 14.0565 14.5312 15.1742C14.6739 16.292 15.0244 17.5869 14.4517 20.6752C13.8791 23.7635 13.4158 26.4888 13.1145 26.8656C12.8125 27.2424 11.8064 27.8478 10.3765 27.5926C9.4038 27.4191 9.11084 27.6746 8.80592 28.1614C8.63099 28.4411 10.816 29.058 13.7135 29.5557C16.6081 30.053 18.6896 30.2352 18.682 29.999C18.6745 29.7627 18.3811 28.7857 17.1091 28.7236C16.545 28.6958 15.6695 28.3067 15.2528 27.9899C14.6316 27.5179 14.3549 26.8392 14.5277 25.8228C14.7005 24.8064 15.4651 19.4696 16.0013 17.992C16.5375 16.5145 16.9596 15.7109 17.8917 15.261C18.8238 14.811 21.2961 14.2576 22.3593 12.9371C23.2661 11.8111 23.6446 10.782 23.5998 7.9697C23.5549 5.15744 22.8453 3.17967 22.8453 3.17967"
                    fill="#E5F2E0"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.7432 6.78182C11.5544 6.84918 10.8704 8.85064 11.5264 10.3057C12.2387 11.8844 13.5035 13.0183 15.9886 13.314C18.4737 13.6096 20.6331 13.0257 21.3554 11.9445C22.0778 10.8633 22.3655 9.35924 22.4074 9.11276C21.8149 9.24179 20.3136 10.0562 18.0312 9.12967C15.7487 8.2031 14.9812 5.6321 11.7432 6.78182Z"
                    fill="#B22624"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11314">
                    <rect width="30" height="30" fill="white" transform="translate(0.780762 0.584961)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMWineActive;

MMWineActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMWineActive.defaultProps = {
    className: null,
};
